import Header from './components/Header'
import Hero from './components/Hero'
import HowItWorks from './components/HowItWorks'
import Footer from './components/Footer'

function App() {
  return (
    <div style={{ margin: 0, padding: 0, fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif", background: '#0a0a0a' }}>
      <Header />
      <Hero />
      <HowItWorks />
      <Footer />
    </div>
  )
}

export default App
